import { RootState } from 'editor/src/store/index';

const getDefaultSpreadTemplateToAdd = (state: RootState) =>
  state.design.designData?.spreads.find((spread) => spread.isTemplate);

export default getDefaultSpreadTemplateToAdd;
